var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-text',[_c('div',{staticStyle:{"position":"relative","height":"320px"}},[_c('BarChartGenerator',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"chart-id":_vm.id}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }